export const environment = {
  production: true,
  entorno: '807',
  timeOut: (60 * 60 * 1000) * 2,     // 2 horas. Milisegundos de inactividad que provocan la DESCONEXIÓN automática (1hora = 60minutos * 60 segundos * 1000 ms)
  timeRefreshCampanyas: 5000,        // Refesco automático de los datos de campañas. 5000 milisegundos = 5 segundos
  timeRefreshPda: 5000,              // Refesco automático de los datos de listados en PDA. 5000 milisegundos = 5 segundos
  timeAutoSave: 120000,              // Auto-guardado en formularios. 120000 milisegundos = 2 minutos

  apiErrorAuth: 'El sistema ha devuelto un error. <br><i>Asegurate de estar autorizado para hacer esta operación</i>',
  defaultTema: 'default-dark.css',


  // URL absoluta de la intranet de cliente
  url_cliente: 'https://clientes.807.innovacen.com',

  // URL de la API
  apiURL: 'https://api.807.innovacen.com/api',

  // Directorios
  dataDir: 'https://api.807.innovacen.com/data',
  fotoDir: 'https://api.807.innovacen.com/data/fotos',
  pdfDir: 'https://api.807.innovacen.com/data/pdfs',
  xlsDir: 'https://api.807.innovacen.com/data/xls',


  // roles
  rolesAdministracion: ['sa', 'admin', 'admin_02'],
};
